import { action, atom } from '@reatom/framework'

import { Deeplink } from '../..'

import type { Network } from '@root/entities/network'
import type { PairAddress } from '@root/entities/pair/model'

export const downloadDeeplinkAtom = atom<Deeplink.Deeplink | undefined>(
  undefined,
  'downloadDeeplinkAtom',
)
export const openDeeplinkDialogAction = action(
  (ctx, options: { deeplink: Deeplink.Deeplink }) => {
    downloadDeeplinkAtom(ctx, options.deeplink)
  },
  'openDeeplinkDialogAction',
)

export const openDownloadDialogAction = action(
  (
    ctx,
    args?: { pair?: { address: PairAddress; network: Network.Network } },
  ) => {
    const deeplink = args?.pair
      ? new Deeplink.Trade({
          network: args.pair.network,
          pair: args.pair.address,
        })
      : new Deeplink.Homepage()

    downloadDeeplinkAtom(ctx, deeplink)
  },
  'openDownloadDialogAction',
)
